export const theme = {
  primaryDark: "#0D0C1D",
  primaryLight: "#EFFFFA",
  primaryTransparency: "rgba(17, 59, 27, 0.3)",
  primaryHover: "#343078",
  mobile: "576px",
};
